import { render, staticRenderFns } from "./PlanDetails.vue?vue&type=template&id=85262150&scoped=true&"
import script from "./PlanDetails.vue?vue&type=script&lang=tsx&"
export * from "./PlanDetails.vue?vue&type=script&lang=tsx&"
import style0 from "./PlanDetails.vue?vue&type=style&index=0&id=85262150&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85262150",
  null
  
)

export default component.exports